import React from "react";

interface Props {
  selectedCars: any[];
  isPupopFromEmail?: boolean;
}
interface State {
  downloadMessage: string;
}

const displaySuccess = () => {};

class BrochureEmailPopup extends React.Component<Props, State> {
  static defaultProps = {
    isPupopFromEmail: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      downloadMessage: window["downloadMessage"],
    };
  }

  views = {
    select: document.getElementById("select"),
    download: document.getElementById("download"),
    post: document.getElementById("post"),
    email: document.getElementById("email"),
    btns: document.querySelector(".brochureDownload__methods") as any,
    overlay: document.querySelector(".custom-download-overlay") as any,
  };

  componentDidMount() {
    const overlay = document.querySelector(".custom-download-overlay") as any;
    const closeButton = document.querySelector(".custom-popup-email-exit");

    closeButton.addEventListener("click", function () {
      overlay.style.display = "none";
    });

    window.addEventListener("click", function (e) {
      if (e.target == overlay) {
        overlay.style.display = "none";
      }
    });

    window["pushDigitalData"](
      {
        event: "_formNavigate",
        form: {
          name: `download a brochure`,
          stage: `download available`,
        },
      },
      true
    );
  }

  validateFields(fieldName: string, fromButton: boolean = false) {
    let isValid: boolean = true;
    let validEmail = false;
    let checkedTerms = false;

    const emailInput = document.getElementById(
      "popup-email-email"
    ) as HTMLInputElement;

    const checkbox = document.getElementById(
      "popup-email-agree"
    ) as HTMLInputElement;

    let policyCheckError = document.getElementById("popup_checkbox_error");
    let emailError = document.getElementById("popup-email_error");

    const email = emailInput.value.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email === "") {
      isValid = false;
      emailError.style.display = fieldName == "email" ? "block" : "none";
    } else if (!emailPattern.test(email)) {
      isValid = false;
      emailError.style.display = fieldName == "email" ? "block" : "none";
    } else {
      emailError.style.display = "none";
      validEmail = true;
    }

    const isChecked = checkbox.checked;
    if (!isChecked) {
      isValid = false;
      policyCheckError.style.display = fieldName == "policy" ? "block" : "none";
    } else {
      policyCheckError.style.display = "none";
      checkedTerms = true;
    }

    if (!fromButton) {
      const submitButton = document.getElementById("tdSubmitEmail") as HTMLButtonElement;
      if (validEmail && checkedTerms) {
        submitButton.disabled = false;
        submitButton.classList.remove("btn--disabled");
      } else {
        submitButton.disabled = true;
        submitButton.classList.add("btn--disabled");
      }
    }


    return isValid;
  }

  pushDigitalData = async () => {

    const emailInput = document.getElementById(
      "popup-email-email"
    ) as HTMLInputElement;

    const email = emailInput.value.trim();

    const _userData = {
      emailHashed: await window["digestStringSHA256"](email),
    };
    const _userFormData = await window["encryptUserData"]({
      encryptedEmail: email,
    });
    window["pushDigitalData"](
      {
        event: "_formNavigate",
        form: {
          name: "email a brochure",
          stage: "submitted",
          details: {
            dealerContact: false,
            vehicleSelected: this.props.selectedCars.map((car) => ({
              make: "Subaru",
              model: car.modelName,
            })),
          },
        },
        user: { ..._userData, ..._userFormData },
      },
      true
    );
  }

  sendEmail = () => {
    let isValid: boolean = true;

    const views = {
      buttonText: document.querySelector(".btn-text") as any,
      buttonSubmitting: document.querySelector(".btn-spinner") as any,
      emailForm: document.getElementById("popup-emailskipForm"),
      submittSuccess: document.querySelector(".popup-email-success-msg") as any,
    };

    if (!this.validateFields("email", true)) {
      isValid = false;
    }
    if (!this.validateFields("policy", true)) {
      isValid = false;
    }

    if (isValid) {
      views.buttonText.style.display = "none";
      views.buttonSubmitting.style.display = "block";

      const emailInput = document.getElementById(
        "popup-email-email"
      ) as HTMLInputElement;

      const email = emailInput.value.trim();
      var formData = {};
      var formValues = $("#brochureForm").serializeArray();
      formValues.forEach(function (item) {
        formData[item.name] = item.value;
      });
      formData["FirstName"] = "noname";
      formData["LastName"] = "noname";
      formData["Email"] = email;
      formData["TocAgreement"] = "True";

      var queryString = $.param(formData);

      $.ajax({
        type: "POST",
        url: "/umbraco/surface/brochuredownloadform/SubmitBrochureDownloadForm", // Update this URL if needed
        data: queryString,
        success: (response) => {
          views.submittSuccess.style.display = "block";
          views.emailForm.style.display = "none";
          this.pushDigitalData();
        },
        error: (xhr, status, error) => {
          alert("Form submission failed: " + error);
        },
      });
    } else {
      views.buttonText.style.display = "block";
      views.buttonSubmitting.style.display = "none";
    }
  };

  render() {
    let downloadMessage = window["downloadMessage"];
    const downloadMessageOverrides = window["downloadMessageOverrides"];
    const messageOverrideForMultipleModel =
      window["messageOverrideForMultipleModel"];
    let carsWithOverrideMsg = [];
    let carText = "";
    downloadMessageOverrides.forEach((overrideItem) => {
      if (
        this.props.selectedCars.find(
          (x) => x.modelName === overrideItem.modelPicker
        )
      ) {
        carsWithOverrideMsg.push(overrideItem.modelPicker);
        if (this.props.selectedCars.length == 1) {
          downloadMessage = overrideItem.messageOverrideForSingleModel;
        } else {
          carText =
            carsWithOverrideMsg.slice(0, -1).join(", ") +
            (carsWithOverrideMsg.length > 1 ? " and " : "") +
            carsWithOverrideMsg.slice(-1);
          downloadMessage = messageOverrideForMultipleModel.replace(
            "[modelNames]",
            carText
          );
        }
      }
    });
    let customiseURL = "/configure";
    let testDriveURL = "/book-test-drive";
    let linkMessage =
      "Your brochures are available through the following links:";

    if (this.props.selectedCars.length == 1) {
      const car = this.props.selectedCars[0];
      const modelNameSlug = car.modelName.toLowerCase();
      testDriveURL = "/book-test-drive";
      customiseURL = "/configure";
      linkMessage = "Your brochure is available through the following link:";
    }

    linkMessage = this.props.isPupopFromEmail
      ? "Your brochure(s) are on their way but are also available below."
      : linkMessage;

    return (
      <div className="custom-popup-email">
        <span className="custom-popup-email-exit">&times;</span>
        <div className="custom-popup-email-container">
          <div className="download-popup-email-container">
            <h2>Thanks for downloading!</h2>
            <p className="custom-popup-email-desktop">{linkMessage}</p>
            <div className="custom-popup-email-images">
              {this.props.selectedCars.map((car) => (
                <div key={car.modelName} className="each-cars">
                  <img src={car.carItem.firstElementChild.currentSrc} />
                  <a
                    className="btn--primary"
                    href={car.carItem.getAttribute("data-brochureLink")}
                    target="_blank"
                    onClick={() => {
                      window["pushDigitalData"](
                        {
                          event: "_formNavigate",
                          form: {
                            name: "download a brochure",
                            stage: "submitted",
                            details: {
                              vehicleSelected: [
                                {
                                  make: "Subaru",
                                  model: car.modelName,
                                },
                              ],
                            },
                          },
                        },
                        true
                      );
                    }}
                  >
                    Download
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="popup-email-form">
            <div id="popup-emailskipForm">
              <p className="popup-email-description">
                Why not send a copy of the brochure <br className="description-line-break"/> straight to your inbox for
                later?
              </p>
              <div className="popup-email-input-group popup-email-text-group">
                <input
                  type="email"
                  id="popup-email-email"
                  name="email"
                  placeholder="Email"
                  onBlur={() => this.validateFields("email")}
                />
                <span className="popup_error" id="popup-email_error">
                  Please enter a valid email address.
                </span>
              </div>

              <div className="popup-email-input-group popup-email-policy-group">
                <label>
                  <input
                    type="checkbox"
                    id="popup-email-agree"
                    onChange={() => this.validateFields("policy")}
                  />
                  <div className="popup-email-privacy-container">
                    <span>
                      Please confirm you have read and agreed to our
                      <strong> Privacy Collection Statement </strong>
                      <br className="privacy-line-break"/>
                      below by checking this box.
                    </span>
                  </div>
                </label>

                <span className="popup_error" id="popup_checkbox_error">
                  You must agree to the Privacy Collection Statement.
                </span>
              </div>

              <button
                type="submit"
                id="tdSubmitEmail"
                className="btn btn--disabled"
                onClick={this.sendEmail}
              >
                <span className="btn-text">Email my brochure</span>
                <span className="btn-spinner" style={{ display: "none" }}>
                  Submitting
                </span>
              </button>
            </div>
            <p className="popup-email-success-msg" style={{ display: "none" }}>
              Your brochure has been sent to your email. <br />
              Please check your inbox!
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default BrochureEmailPopup;
